import React, { useState, useEffect } from 'react';
import apiFetch from '@wordpress/api-fetch';
import { renderInputRow } from '../../../utils/renderInputRow';
import { Button } from '../../../components/ui/index.jsx';
import { useToast } from '../../../components/ui/Toast.jsx';

const AdminEmailSettingTab = () => {
    const toast = useToast();
    const [originalAdminEmailSettings, setOriginalAdminEmailSettings] = useState({});
    const [adminEmailSettings, setAdminEmailSettings] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const global = window.BPSFW_GLOBAL_OPTIONS || {};
        setAdminEmailSettings(global);
        setOriginalAdminEmailSettings(global);
    }, []);

    const handleSave = () => {
        const changedData = Object.fromEntries(
            Object.entries(adminEmailSettings).filter(([key, value]) => originalAdminEmailSettings[key] !== value)
        );
        if (Object.keys(changedData).length === 0) {
            toast.info('No changes detected.');
            return;
        }
        setLoading(true);
        apiFetch({ path: '/wp/v2/settings', method: 'POST', data: changedData })
            .then(() => {
                toast.success('Administrator email settings saved!');
                window.BPSFW_GLOBAL_OPTIONS = { ...(window.BPSFW_GLOBAL_OPTIONS || {}), ...adminEmailSettings };
                setOriginalAdminEmailSettings(adminEmailSettings);
            })
            .catch((err) => {
                console.error('Error saving administrator email settings:', err);
                toast.error('Error saving administrator email settings.');
            })
            .finally(() => setLoading(false));
    };

    const updateNewRegistrationSetting = (key, value) => {
        setAdminEmailSettings({ ...adminEmailSettings, [key]: value });
    };

    return (
        <div className="plugin-notification-setting-tab">
            {loading && (
                <div className="bpsfw-overlay-loader">
                    <div className="bpsfw-loader-box">
                        <div className="bpsfw-spinner"></div>
                        <span className="bpsfw-loader-text">Saving changes…</span>
                    </div>
                </div>
            )}

            {/* ── Admin Notifications Toggle ── */}
            <div className="bpsfw-section-card">
                <div className="bpsfw-section-header">
                    <div className="bpsfw-section-icon">📧</div>
                    <div>
                        <div className="bpsfw-section-title">Administrator Email Notifications</div>
                        <div className="bpsfw-section-subtitle">Emails sent to the administrator on user status changes</div>
                    </div>
                </div>
                <div className="bpsfw-section-body">
                    {renderInputRow(
                        'Enable Admin Emails',
                        'bpsfw_admin_email',
                        'checkBox', [],
                        'Send emails to the administrator when users are approved or rejected',
                        '', adminEmailSettings, updateNewRegistrationSetting
                    )}
                </div>
            </div>

            {/* ── Admin Rejection Email ── */}
            <div className="bpsfw-section-card">
                <div className="bpsfw-section-header">
                    <div className="bpsfw-section-icon">🚫</div>
                    <div>
                        <div className="bpsfw-section-title">Admin Rejection Notification</div>
                        <div className="bpsfw-section-subtitle">Email the admin receives when a user is rejected</div>
                    </div>
                </div>
                <div className="bpsfw-section-body">
                    {renderInputRow('Rejection Email Subject', 'bpsfw_admin_reject_email_subject', '', [], '', '', adminEmailSettings, updateNewRegistrationSetting)}
                    {renderInputRow('Rejection Email Message', 'bpsfw_admin_reject_email_message', 'textArea', [], '', '', adminEmailSettings, updateNewRegistrationSetting, <>{`Use `}<code>{'{customer_name}'}</code>{` to include customer name in the email.`}</>)}
                </div>
            </div>

            {/* ── Admin Approval Email ── */}
            <div className="bpsfw-section-card">
                <div className="bpsfw-section-header">
                    <div className="bpsfw-section-icon">🎉</div>
                    <div>
                        <div className="bpsfw-section-title">Admin Approval Notification</div>
                        <div className="bpsfw-section-subtitle">Email the admin receives when a user is approved</div>
                    </div>
                </div>
                <div className="bpsfw-section-body">
                    {renderInputRow('Approval Email Subject', 'bpsfw_admin_approve_email_subject', '', [], '', '', adminEmailSettings, updateNewRegistrationSetting)}
                    {renderInputRow('Approval Email Message', 'bpsfw_admin_approve_email_message', 'textArea', [], '', '', adminEmailSettings, updateNewRegistrationSetting, <>{`Use `}<code>{'{customer_name}'}</code>{` to include customer name in the email.`}</>)}
                </div>
            </div>

            <div className="bpsfw-save-row">
                <Button variant="primary" onClick={handleSave}>Save Changes</Button>
            </div>
        </div>
    );
};

export default AdminEmailSettingTab;
